import { Col, Container, Row } from "react-grid-system";
import { Cabecalho } from "./componentes/Cabecalho/cabecalho";
import { CampoTexto } from "./componentes/CampoTexto/CampoTexto";
import { Card } from "./componentes/Card/Card";
import { Estilos } from "./componentes/EstilosGlobais/Estilos";
import { Rodape } from "./componentes/Rodape/Rodape";
import { ProvedorTema } from "./componentes/Tema/Tema";
import { Tipografia } from "./componentes/Tipografia/Tipografia";
import { Botao } from "./componentes/Botao/Botao";
import { Logo } from "./componentes/Icones/Logo";
import { Link } from "./componentes/Icones/Link";
import { ListaInline } from "./componentes/Lista/ListaInline";
import { ItemListaInline } from "./componentes/Lista/ItemListaInline";
import { IconeWhatsApp } from "./componentes/Icones/IconeWhatsApp";
import { IconeTwitch } from "./componentes/Icones/IconeTwitch";
import { IconeInstagram } from "./componentes/Icones/IconeInstagram";
import { IconeTwitter } from "./componentes/Icones/IconeTwitter";

function App() {
  return (
    <ProvedorTema>
      <Cabecalho>
        <Container>
          <Row align="center">
            <Col>
              <Logo />
            </Col>
            <Col style={{ textAlign: "right" }}>
              <Link></Link>
            </Col>
          </Row>
        </Container>
      </Cabecalho>
      <Estilos />
      <Container style={{ marginTop: "80px ", marginBottom: "80px" }}>
        <Row justify="center">
          <Col lg={6} md={8} sm={12}>
            <Card>
              <Tipografia variante="h3" componente="h1">
                Freelando
              </Tipografia>
              <Tipografia variante="body" componente="body">
                Crie seu perfil gratuitamente para começar a trabalhar com os
                melhores freelancers. Em seguida, você poderá dar mais detalhes
                sobre suas demandas e sobre sua forma de trabalho.
              </Tipografia>
              <Tipografia variante="body" componente="body">
                {" "}
                Vale notar que o formulário do site é totalmente front-end. Ele
                não possui integração com um servidor de back-end nem banco de
                dados para processar, enviar ou armazenar as informações
                digitadas.
              </Tipografia>
              <Row>
                <Col>
                  <CampoTexto titulo="Nome Completo" />
                </Col>
              </Row>
              <Row>
                <Col lg={8} md={8} sm={8}>
                  <CampoTexto titulo="Cidade" />
                </Col>
              </Row>
              <Row>
                <Col>
                  <CampoTexto titulo="E-mail" />
                </Col>
              </Row>
              <Row>
                <Col lg={6} md={6} sm={6}>
                  <CampoTexto titulo="Senha" />
                </Col>
                <Col lg={6} md={6} sm={6}>
                  <CampoTexto titulo="Repita a Senha" />
                </Col>
              </Row>
              <Row>
                <Col lg={6} md={6} sm={6}>
                  <Botao variante="secundaria">Anterior</Botao>
                </Col>
                <Col lg={6} md={6} sm={6}>
                  <div style={{ textAlign: "right" }}>
                    <Botao>Próxima</Botao>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
      <Rodape>
        <Container>
          <Row align="center">
            <Col>
              <Logo height={40} width={176} />
              <Tipografia variante="legenda" componente="legenda">
                Desenvolvido por André. Projeto fictício sem fins comerciais.
              </Tipografia>
            </Col>
            <Col style={{ textAlign: "right" }}>
              <Tipografia variante="legenda" componente="legenda">
                Acesse nossas redes:
              </Tipografia>
              <ListaInline>
                <ItemListaInline>
                  <a href="/" aria-label="Link para o WhatsApp">
                    <IconeWhatsApp />
                  </a>
                </ItemListaInline>
                <ItemListaInline>
                  <a
                    href="https://www.twitch.tv/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Link para a Twitch"
                  >
                    <IconeTwitch />
                  </a>
                </ItemListaInline>
                <ItemListaInline>
                  <a
                    href="https://www.instagram.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Link para a Instagram"
                  >
                    <IconeInstagram />
                  </a>
                </ItemListaInline>
                <ItemListaInline>
                  <a
                    href="https://x.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Link para a Twitter"
                  >
                    <IconeTwitter />
                  </a>
                </ItemListaInline>
              </ListaInline>
            </Col>
          </Row>
        </Container>
      </Rodape>
    </ProvedorTema>
  );
}

export default App;
